import { render, staticRenderFns } from "./CardShippingFeeForm.vue?vue&type=template&id=e97c8f10&scoped=true&"
import script from "./CardShippingFeeForm.vue?vue&type=script&lang=js&"
export * from "./CardShippingFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./CardShippingFeeForm.vue?vue&type=style&index=0&id=e97c8f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c8f10",
  null
  
)

export default component.exports